import React from 'react'
import { Route } from "react-router-dom"
import PrivateRoute from '../../utils/PrivateRoute'
import GWASViz from './GWAS/GWASViz'
import GWASSingleTrait from './GWAS/GWASSingleTrait'
import GWASMultiTrait from './GWAS/GWASMultiTrait'
import AuthService from '../../utils/auth.service'
import PopExpression from './Expression/PopExpression'
import RefExpression from './Expression/RefExpression'
import EQTLviz from './eQTLviz/eQTLviz'
import SnpPrimer from './SnpPrimer/SnpPrimer'
import GeneNetwork from './GeneNetwork/GeneNetwork'
import IdConverter from './IdConverter'
import JbrowseNav from './Jbrowse/Jbrowse'

class Tool extends React.Component {
    render() {
        const isLogin = AuthService.isLogin()

        return (
            <React.Fragment>
                <Route path="/tool/jbrowse_nav">
                    <JbrowseNav />
                </Route>
				<Route path="/tool/pop_expression">
                    <PopExpression />
                </Route>
                <Route path="/tool/ref_expression">
                    <RefExpression />
                </Route>
                <Route path="/tool/gwasviz">
                    <GWASViz />
                </Route>
                <Route path="/tool/gwas_single_trait/:species/:trait?/:loc_chr?/:loc_start?/:loc_end?">
                    <GWASSingleTrait />
                </Route>
                <Route path="/tool/gwas_multi_trait/:species">
                    <GWASMultiTrait />
                </Route>
		<Route path="/tool/eqtlviz">
                    <EQTLviz />
                </Route>
                <Route path="/tool/snp_primer">
                    <SnpPrimer />
                </Route>
                <Route path="/tool/gene_network">
                    <GeneNetwork />
                </Route>
                <Route path="/tool/id_converter">
                    <IdConverter />
                </Route>
            </React.Fragment>
        )
    }
}

export default Tool
